export default __webpack_public_path__ + "static/media/NotoSansSCRegular-subset.a72bc119.woff";